import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="m44.909 34.326 5.466-2.345c.46-.197.757-.65.757-1.15v-6.58c0-.691.558-1.251 1.247-1.251h10.967c.688 0 1.247.56 1.247 1.25v6.313c0 .495.29.943.742 1.143l5.832 2.591c.46.204.997.111 1.363-.235l4.64-4.406a1.244 1.244 0 0 1 1.741.025l7.535 7.592c.49.494.483 1.295-.016 1.78l-4.582 4.455a1.25 1.25 0 0 0-.261 1.428l2.629 5.64c.205.44.645.721 1.13.721h6.407c.689 0 1.247.56 1.247 1.25v10.904c0 .69-.558 1.25-1.247 1.25h-5.94c-.486 0-.928.283-1.133.725l-2.823 6.11a1.25 1.25 0 0 0 .256 1.416l4.336 4.278c.49.484.497 1.274.015 1.767l-7.423 7.594c-.491.502-1.3.5-1.787-.006l-4.187-4.336a1.25 1.25 0 0 0-1.365-.29l-6.23 2.529c-.475.193-.785.659-.779 1.173l.069 6.074A1.25 1.25 0 0 1 63.515 93h-11.06c-.683 0-1.24-.55-1.247-1.236l-.069-5.817a1.25 1.25 0 0 0-.694-1.106l-5.485-2.72a1.25 1.25 0 0 0-1.405.208l-4.532 4.25a1.245 1.245 0 0 1-1.744-.038L30 79.091a1.253 1.253 0 0 1 .015-1.767l4.237-4.18c.379-.373.48-.945.253-1.426l-2.719-5.761a1.25 1.25 0 0 0-1.127-.717h-6.41c-.69 0-1.248-.56-1.248-1.25V52.962c0-.69.558-1.25 1.247-1.25h6.29c.497 0 .946-.296 1.144-.752l2.581-5.95c.206-.474.1-1.027-.27-1.39l-4.327-4.27c-.5-.493-.497-1.3.005-1.79l7.636-7.43a1.245 1.245 0 0 1 1.69-.044l4.596 4.03c.36.316.87.397 1.312.208z"
    />
    <path
      fill="#7B8493"
      d="M57.803 60.925c4.833 0 8.75-3.86 8.75-8.623 0-4.762-3.917-8.622-8.75-8.622s-8.752 3.86-8.752 8.622 3.918 8.623 8.752 8.623"
    />
    <path
      fill="#7B8493"
      d="M70.535 70.17a.708.708 0 0 0 .622-1.046c-2.462-4.665-7.538-8.2-13.18-8.2-5.9 0-10.984 3.444-13.293 8.403-.213.457.152.976.663.973z"
    />
    <path fill="#ACB8C3" d="M90.5 27a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M41.636 93.082a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M29.52 93.082a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M58.171 109.164a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M102.879 30.412a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V31.912a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M94.313 38.98a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H95.813a1.5 1.5 0 0 1-1.5-1.5M11.566 31.722a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconManageGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconManageGreyscale);
export default Memo;
